/**
 * The sheet's stylesheet, injected with the sheet and removed with it.
 *
 * A card over a scrim, scrolling inside itself rather than moving the menu underneath. The menu is
 * still there and still readable at the edges, because this is a detour and not a screen change.
 */

import { injectCss } from '@/ui/cssInjector';

const CSS = `
.sheet {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:
    calc(env(safe-area-inset-top, 0px) + clamp(12px, 4vh, 40px))
    calc(env(safe-area-inset-right, 0px) + clamp(12px, 4vw, 40px))
    calc(env(safe-area-inset-bottom, 0px) + clamp(12px, 4vh, 40px))
    calc(env(safe-area-inset-left, 0px) + clamp(12px, 4vw, 40px));
  background: rgba(8, 9, 11, 0.72);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}

.sheet-card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: min(100%, 760px);
  max-height: 100%;
  border: 1px solid rgba(242, 237, 227, 0.18);
  border-radius: 10px;
  background: linear-gradient(160deg, rgba(22, 24, 28, 0.97), rgba(12, 13, 15, 0.98));
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.65);
}

.sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px 12px clamp(16px, 3vw, 22px);
  border-bottom: 1px solid rgba(242, 237, 227, 0.12);
}

.sheet-title {
  margin: 0;
  font-size: clamp(13px, 3.2vw, 15px);
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.sheet-close {
  min-height: 44px;
  padding: 0 16px;
  border: 1px solid rgba(242, 237, 227, 0.28);
  border-radius: 6px;
  background: rgba(242, 237, 227, 0.06);
  color: rgba(242, 237, 227, 0.86);
  font: inherit;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
}

.sheet-close:hover, .sheet-close:focus-visible { background: rgba(242, 237, 227, 0.16); }
.sheet-close:focus-visible { outline: 2px solid #e8b34a; outline-offset: 2px; }

/* The card scrolls, not the menu behind it. */
.sheet-body {
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: clamp(14px, 3vw, 20px);
}
`;

/** Injects the sheet stylesheet. Returns a function that removes it again. */
export function injectMenuSheetStyles(): () => void {
  return injectCss(CSS);
}
